var map = {
	"./spells-aag.json": 7239,
	"./spells-ai.json": 4782,
	"./spells-aitfr-avt.json": 578,
	"./spells-bmt.json": 7416,
	"./spells-dodk.json": 1616,
	"./spells-egw.json": 4525,
	"./spells-ftd.json": 8490,
	"./spells-ggr.json": 7016,
	"./spells-ghloe.json": 3837,
	"./spells-hwcs.json": 3647,
	"./spells-idrotf.json": 3060,
	"./spells-llk.json": 1185,
	"./spells-phb.json": 638,
	"./spells-sato.json": 3801,
	"./spells-scc.json": 3251,
	"./spells-tce.json": 7100,
	"./spells-tdcsr.json": 8584,
	"./spells-xge.json": 8652,
	"./spells-xphb.json": 9206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9123;